import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

export const PrivacyPage = () => {
  const { t } = useTranslation();
  return (
  <div className="max-w-[800px] mx-auto py-[32px] md:py-[48px]">
    <h1 className="font-display text-[28px] md:text-[36px] font-bold text-base-black tracking-[-0.5px] mb-[4px]">
      {t('privacy.title')}
    </h1>
    <p className="font-body text-[13px] text-[#818185] mb-[32px]">{t('privacy.lastUpdated')}</p>

    <article className="font-body text-[14px] text-[#374151] leading-relaxed flex flex-col gap-[24px]">
      <p>
        {t('privacy.intro')}
      </p>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.collectTitle')}</h2>
        <p className="font-semibold text-base-black mb-[4px]">{t('privacy.accountInfo')}</p>
        <p>{t('privacy.accountInfoP1')}</p>
        <p className="font-semibold text-base-black mb-[4px] mt-[12px]">{t('privacy.usageData')}</p>
        <p>{t('privacy.usageDataP1')}</p>
        <p className="font-semibold text-base-black mb-[4px] mt-[12px]">{t('privacy.reviewData')}</p>
        <p>{t('privacy.reviewDataP1')}</p>
        <p className="font-semibold text-base-black mb-[4px] mt-[12px]">{t('privacy.cookies')}</p>
        <p>{t('privacy.cookiesP1')}</p>
        <p className="font-semibold text-base-black mb-[4px] mt-[12px]">{t('privacy.paymentData')}</p>
        <p>{t('privacy.paymentDataP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.useTitle')}</h2>
        <ul className="list-disc ml-[20px] flex flex-col gap-[4px]">
          <li>{t('privacy.useItem1')}</li>
          <li>{t('privacy.useItem2')}</li>
          <li>{t('privacy.useItem3')}</li>
          <li>{t('privacy.useItem4')}</li>
          <li>{t('privacy.useItem5')}</li>
          <li>{t('privacy.useItem6')}</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.shareTitle')}</h2>
        <p>{t('privacy.shareIntro')}</p>
        <ul className="list-disc ml-[20px] mt-[8px] flex flex-col gap-[4px]">
          <li><Trans i18nKey="privacy.shareItem1" components={{ strong: <strong /> }} /></li>
          <li><Trans i18nKey="privacy.shareItem2" components={{ strong: <strong /> }} /></li>
          <li><Trans i18nKey="privacy.shareItem3" components={{ strong: <strong /> }} /></li>
          <li><Trans i18nKey="privacy.shareItem4" components={{ strong: <strong /> }} /></li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.retentionTitle')}</h2>
        <p>{t('privacy.retentionP1')}</p>
        <p className="mt-[8px]">{t('privacy.paymentDataRetention')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.dataSecurityTitle')}</h2>
        <p>{t('privacy.dataSecurityP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.rightsTitle')}</h2>
        <p>{t('privacy.rightsIntro')}</p>
        <ul className="list-disc ml-[20px] mt-[8px] flex flex-col gap-[4px]">
          <li><Trans i18nKey="privacy.rightsAccess" components={{ strong: <strong /> }} /></li>
          <li><Trans i18nKey="privacy.rightsCorrection" components={{ strong: <strong /> }} /></li>
          <li><Trans i18nKey="privacy.rightsDeletion" components={{ strong: <strong /> }} /></li>
          <li><Trans i18nKey="privacy.rightsPortability" components={{ strong: <strong /> }} /></li>
          <li><Trans i18nKey="privacy.rightsObjection" components={{ strong: <strong /> }} /></li>
        </ul>
        <p className="mt-[8px]">{t('privacy.rightsContact')} <a href="mailto:contact@squarebitstudios.com" className="text-base-black font-semibold underline">contact@squarebitstudios.com</a>.</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.ccpaTitle')}</h2>
        <p>{t('privacy.ccpaP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.gdprTitle')}</h2>
        <p>{t('privacy.gdprP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.childrenTitle')}</h2>
        <p>{t('privacy.childrenP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.changesToPolicyTitle')}</h2>
        <p>{t('privacy.changesToPolicyP1')}</p>
      </section>

      <section>
        <h2 className="font-display text-[20px] font-bold text-base-black mb-[8px]">{t('privacy.contactTitle')}</h2>
        <p>{t('privacy.contactP1')} <a href="mailto:contact@squarebitstudios.com" className="text-base-black font-semibold underline">contact@squarebitstudios.com</a>.</p>
        <p className="mt-[4px]">{t('privacy.contactAddress')}</p>
      </section>
    </article>
  </div>
  );
};
